import React, { PropsWithChildren } from 'react';
import { Container } from '@landr/maestro';
import { css, cx } from '@landr/styled-system/css';
import { ContentProps, ContentPositionType } from './Content.types';

// Position variants mapping
const positionStyles: Record<ContentPositionType, string> = {
    center: css({
        alignItems: 'center',
        textAlign: 'center',
    }),
    left: css({
        alignItems: 'flex-start',
        textAlign: 'left',
    }),
    right: css({
        alignItems: 'flex-end',
        textAlign: 'right',
    }),
};

const contentBaseStyles = css({
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'center',
    whiteSpace: 'normal',
});

const Content: React.FC<PropsWithChildren<ContentProps>> = ({
    children,
    contentPosition = 'left',
    ...styleProps
}) => {
    return (
        <Container
            className={cx(
                contentBaseStyles,
                positionStyles[contentPosition],
                css({
                    py: {
                        base: '2xl',
                        md: '4xl',
                    },
                    ...styleProps,
                }),
            )}
        >
            {children}
        </Container>
    );
};

Content.displayName = 'Section.Content';

export default Content;
